// vue
import { ref } from '@vue/composition-api';

// turf
import * as turf from '@turf/turf';

// mapboxgl
import mapboxgl from 'mapbox-gl';

export const updateGeoRecordRotation = () => {
    const updateRotationDegree = (
        draw: mapboxgl.Draw,
        rotationAngle: number,
    ) => {
        // refs
        const poly = ref();
        const centroid = ref();

        switch (draw.get('test').geometry.type) {
            case 'Polygon':
                poly.value = turf.polygon(
                    draw.get('test').geometry.coordinates,
                );
                centroid.value = turf.centroid(
                    turf.polygon(draw.get('test').geometry.coordinates),
                );
                break;
            case 'MultiPolygon':
                poly.value = turf.multiPolygon(
                    draw.get('test').geometry.coordinates,
                );
                centroid.value = turf.centroid(
                    turf.multiPolygon(draw.get('test').geometry.coordinates),
                );
                break;
            case 'MultiLineString':
                poly.value = turf.multiLineString(
                    draw.get('test').geometry.coordinates,
                );
                centroid.value = turf.centroid(
                    turf.multiLineString(draw.get('test').geometry.coordinates),
                );
                break;
            case 'MultiPoint':
                poly.value = turf.multiPoint(
                    draw.get('test').geometry.coordinates,
                );
                centroid.value = turf.centroid(
                    turf.multiPoint(draw.get('test').geometry.coordinates),
                );
                break;
        }

        let options = {
            pivot: centroid.value?.geometry?.coordinates,
            mutate: false,
        };
        let oldAngle = draw.get('test').properties.rotation;
        let isRectangle = draw.get('test').properties.isRectangle;
        let vertexLabelState = draw.get('test').properties.vertexLabelState;
        let smoothCount = draw.get('test').properties.smoothCount;
        let newAngle = rotationAngle - oldAngle;
        let rotatedPoly = turf.transformRotate(poly.value, newAngle, options);

        draw.delete('test');
        draw.add({
            id: 'test',
            type: 'Feature',
            properties: {
                rotation: oldAngle,
                isRectangle: isRectangle,
                vertexLabelState: vertexLabelState,
                smoothCount: smoothCount,
            },
            geometry: rotatedPoly.geometry,
        });
    };
    return { updateRotationDegree };
};
